import {z} from '@hono/zod-openapi';

/** `car_details`: the matching ads, an empty array when nothing matched. */
export const priceReportCarDetailsResponseSchema = z
  .object({result: z.array(z.unknown())})
  .openapi('PriceReportCarDetailsResponse');
